import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';

@Component({
  selector: 'vr-delete-modal',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public defaults: any,
              private dialogRef: MatDialogRef<DeleteDialogComponent>
  ) {}

  cancel() {
    this.dialogRef.close({delete: false});
  }

  delete() {
    this.dialogRef.close({delete: true});
  }

}



// WEBPACK FOOTER //
// /home/web_clients/qualicheck.fr/preprod/erp/src/app/core/dialogs/edit-audit-item-dialog/deleted-dialog/delete-dialog.component.ts